import React from 'react';
import { Reveal } from './showcase/Reveal';
import { VignetteFrame } from './showcase/VignetteFrame';
import { CountUp } from './showcase/CountUp';
const breakdown: {
  label: string;
  value: number;
}[] = [{
  label: 'Claimed, one call, no answer',
  value: 1846
}, {
  label: 'No second attempt logged',
  value: 1204
}, {
  label: 'Reassigned to a new agent',
  value: 388
}];
export function JunkLeadSpiral() {
  return <section id="junk-leads" aria-labelledby="junk-leads-title" className="border-b border-white/5 bg-ink-800" data-id="element-162" data-mp="mif53q0t0axd">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-163" data-mp="ql1r3aasn1mn">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-164" data-mp="vgh11r5okdds">
          <Reveal data-id="element-165" data-mp="10i6e1ccgr14i">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-166" data-mp="10ipyazpl61lp">
              The spiral
            </p>
            <h2 id="junk-leads-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-167" data-mp="26zl4nps9ati4">
              The junk lead spiral.
            </h2>
            <div className="mt-6 max-w-xl space-y-4 text-base leading-relaxed text-white/65" data-id="element-168" data-mp="1xuealqx6x2cw">
              <p data-id="element-169" data-mp="1svbi15yecolt">
                Your CRM is filling with one-touch leads. A lead comes in, gets claimed,
                one call, no answer, parked forever.
              </p>
              <p data-id="element-170" data-mp="1ixnafffozmm8">
                The good agents wait for the layup. The pile gets handed to your newest
                agent as opportunity. They dial dead leads all day, decide the business
                does not work, and quit. Then you recruit again and the pile is bigger.
              </p>
            </div>
            <p className="mt-6 max-w-xl border-l-2 border-brand pl-5 font-display text-lg leading-relaxed text-white/85" data-id="element-171" data-mp="156sbovywqlwd">
              That is not an agent problem. It is a system that lets a lead die with nobody
              noticing.
            </p>
          </Reveal>

          <Reveal delay={0.1} data-id="element-172" data-mp="vaf7v59nernw">
            <VignetteFrame label="One-touch leads" timestamp="Demo data" data-id="element-173" data-mp="ljxeaw7slpzg">
              <div className="text-center" data-id="element-174" data-mp="qjjw7iykfuel">
                <p className="font-display text-5xl font-bold tracking-tight text-brand sm:text-6xl" data-id="element-175" data-mp="qkcstr3t93j0">
                  <CountUp value={3438} duration={1.6} data-id="element-176" data-mp="cl3njmh57ttt" />
                </p>
                <p className="mt-3 text-sm text-white/50" data-id="element-177" data-mp="gklxjn7fekhv">
                  contacts with exactly one logged attempt
                </p>
              </div>

              <ul className="mt-7 space-y-3 border-t border-white/10 pt-5" data-id="element-178" data-mp="14dat9rv41ltf">
                {breakdown.map((row, index) => <li key={row.label} data-id="element-179" data-mp="viwj23pft1h6" data-mpi={index}>
                    <Reveal delay={0.12 * index} offset={8} className="flex items-baseline justify-between gap-4" data-id="element-180" data-mp="vi4w1h9woc2i">
                      <span className="text-sm text-white/60" data-id="element-181" data-mp="1n89e39a70n0k">{row.label}</span>
                      <span className="text-sm font-semibold text-white/85" data-id="element-182" data-mp="1s1kkj9b3f1ry">
                        <CountUp value={row.value} duration={1.4} data-id="element-183" data-mp="3cqfy4s939odl" />
                      </span>
                    </Reveal>
                  </li>)}
              </ul>
            </VignetteFrame>
          </Reveal>
        </div>
      </div>
    </section>;
}